import { v4 as uuid } from 'uuid'
export const categoryList = [
  {
    thumbnailUrl:
      'https://60a99bedadae98078522-a9b6cded92292ef3bace063619038eb1.ssl.cf2.rackcdn.com/images_CategoryImages_laptops_062022.jpg',
    title: 'Laptop',
  },

  {
    thumbnailUrl:
      'https://60a99bedadae98078522-a9b6cded92292ef3bace063619038eb1.ssl.cf2.rackcdn.com/images_CategoryImages_desktops_062022.jpg',
    title: 'Máy bàn',
  },
  {
    thumbnailUrl:
      'https://60a99bedadae98078522-a9b6cded92292ef3bace063619038eb1.ssl.cf2.rackcdn.com/images_CategoryImages_11_2021APPLE500.jpg',
    title: 'Apple',
  },
  {
    thumbnailUrl:
      'https://60a99bedadae98078522-a9b6cded92292ef3bace063619038eb1.ssl.cf2.rackcdn.com/images_CategoryImages_monitors_062022a.jpg',
    title: 'Màng hình',
  },
]

export const accessoryList = [
  {
    thumbnailUrl:
      'https://60a99bedadae98078522-a9b6cded92292ef3bace063619038eb1.ssl.cf2.rackcdn.com/images_CategoryImages_videoCards500.jpg',
    title: 'VGA',
  },
  {
    thumbnailUrl:
      'https://60a99bedadae98078522-a9b6cded92292ef3bace063619038eb1.ssl.cf2.rackcdn.com/images_CategoryImages_IntelAMDProcessors500.jpg',
    title: 'CPU',
  },
  {
    thumbnailUrl:
      'https://60a99bedadae98078522-a9b6cded92292ef3bace063619038eb1.ssl.cf2.rackcdn.com/images_CategoryImages_motherboards_062022.jpg',
    title: 'Main',
  },
  {
    thumbnailUrl:
      'https://60a99bedadae98078522-a9b6cded92292ef3bace063619038eb1.ssl.cf2.rackcdn.com/images_CategoryImages_ssds_062022.jpg',
    title: 'SSD',
  },
  {
    thumbnailUrl:
      'https://60a99bedadae98078522-a9b6cded92292ef3bace063619038eb1.ssl.cf2.rackcdn.com/images_CategoryImages_memory_062022.jpg',
    title: 'Ram',
  },
  {
    thumbnailUrl:
      'https://60a99bedadae98078522-a9b6cded92292ef3bace063619038eb1.ssl.cf2.rackcdn.com/images_CategoryImages_PowerSupplies500_062022.jpg',
    title: 'Nguồn',
  },
  {
    thumbnailUrl:
      'https://60a99bedadae98078522-a9b6cded92292ef3bace063619038eb1.ssl.cf2.rackcdn.com/images_CategoryImages_cooling_500.jpg',
    title: 'Fan led',
  },
  {
    thumbnailUrl:
      'https://60a99bedadae98078522-a9b6cded92292ef3bace063619038eb1.ssl.cf2.rackcdn.com/images_CategoryImages_ComputerCases500_062022.jpg',
    title: 'Case PC',
  },
]

export const productList = [
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'Laptop văn phòng',
    price: 5000000,
    thumbnailUrl:
      'https://cdn.tgdd.vn/Products/Images/44/263977/TimerThumb/acer-travelmate-b3-tmb311-31-p49d-n5030-nxvnfsv005-(25).jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'Laptop văn phòng',
    price: 5000000,
    thumbnailUrl:
      'https://cdn.tgdd.vn/Products/Images/44/263977/TimerThumb/acer-travelmate-b3-tmb311-31-p49d-n5030-nxvnfsv005-(25).jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'Laptop văn phòng',
    price: 5000000,
    thumbnailUrl:
      'https://cdn.tgdd.vn/Products/Images/44/263977/TimerThumb/acer-travelmate-b3-tmb311-31-p49d-n5030-nxvnfsv005-(25).jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'Laptop văn phòng',
    price: 5000000,
    thumbnailUrl:
      'https://cdn.tgdd.vn/Products/Images/44/263977/TimerThumb/acer-travelmate-b3-tmb311-31-p49d-n5030-nxvnfsv005-(25).jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'Laptop văn phòng',
    price: 5000000,
    thumbnailUrl:
      'https://cdn.tgdd.vn/Products/Images/44/263977/TimerThumb/acer-travelmate-b3-tmb311-31-p49d-n5030-nxvnfsv005-(25).jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'Laptop văn phòng',
    price: 5000000,
    thumbnailUrl:
      'https://cdn.tgdd.vn/Products/Images/44/263977/TimerThumb/acer-travelmate-b3-tmb311-31-p49d-n5030-nxvnfsv005-(25).jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'Laptop văn phòng',
    price: 5000000,
    thumbnailUrl:
      'https://cdn.tgdd.vn/Products/Images/44/263977/TimerThumb/acer-travelmate-b3-tmb311-31-p49d-n5030-nxvnfsv005-(25).jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
  {
    id: uuid(),
    title: 'ACER CORE I5',
    category: 'Laptop văn phòng',
    price: 5000000,
    thumbnailUrl:
      'https://cdn.tgdd.vn/Products/Images/44/263977/TimerThumb/acer-travelmate-b3-tmb311-31-p49d-n5030-nxvnfsv005-(25).jpg',
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    info: {
      screen: '13 inch, HD ',
      CPU: 'Pentium, N5030, 1.1GHz',
      card: 'Intel UHD 605',
      battery: '3-cell, 48Wh',
      weight: '1.4 kg',
    },
  },
]

export const categoryMenu = [
  {
    label: 'Máy tính bàn',
  },
  {
    label: 'Laptop',
  },
  {
    label: 'Màng hình',
  },
  {
    label: 'Linh kiện',
  },
]

export const footerPageList = [
  { label: 'Giới thiệu', link: 'gioi-thieu' },
  { label: 'Liên hệ', link: 'lien-he' },
]

export const socialList = [
  {
    label: 'Instagram',
  },
  {
    label: 'Facebook',
  },
  {
    label: 'LinkedIn',
  },
  {
    label: 'Youtube',
  },
]

export const computerList = [
  'https://templatecat-megabyte.netlify.app/img/brands/lenovo-logo.png',
  'https://templatecat-megabyte.netlify.app/img/brands/logitech-logo.png',
  'https://templatecat-megabyte.netlify.app/img/brands/msi-logo.png',
  'https://templatecat-megabyte.netlify.app/img/brands/nvidia-logo.png',
  'https://templatecat-megabyte.netlify.app/img/brands/samsung-logo.png',
  'https://templatecat-megabyte.netlify.app/img/brands/amd-logo.png',
  'https://templatecat-megabyte.netlify.app/img/brands/asus-logo.png',
  'https://templatecat-megabyte.netlify.app/img/brands/gigabyte-logo.png',
  'https://templatecat-megabyte.netlify.app/img/brands/hp-logo.png',
  'https://templatecat-megabyte.netlify.app/img/brands/intel-logo.png',
  // 'https://templatecat-megabyte.netlify.app/img/brands/kingston-logo.png',
]
